import {
  FileText,
  Image as ImageIcon,
  FileSpreadsheet,
  File,
} from "lucide-react";

export const getFileIcon = (fileName) => {
  const ext = fileName.split(".").pop().toLowerCase();
  switch (ext) {
    case "pdf":
      return <FileText className="text-red-500" size={20}/>;
    case "jpg":
    case "jpeg":
    case "png":
    case "gif":
      return <ImageIcon className="text-blue-500" size={20}/>;
    case "xls":
    case "xlsx":
    case "csv":
      return <FileSpreadsheet className="text-green-500" size={20}/>;
    default:
      return <File className="text-gray-500" size={20} />;
  }
};

export const getFileNameFromUrl = (url) => {
  try {
    const cleanUrl = url.split("?")[0];
    return cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1);
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
}